import './linear-progress.scss';
import LinearProgressContainer from './linear-progress-container';

export default LinearProgressContainer;
